export const mandatoryStyles = `
.ft-mandatory-label {
    color: rgba(199, 37, 78, 0.87);
}
`;
